import { fileApi } from ".";
import { PageRequest, PagedResponse } from "@/api/types";

export interface File {
    id: number;
    customerId: number;
    externalFileId?: string;
    internalFileId?: string;
    fileName?: string;
    url?: string;
    mimeTypeId?: number;
    checksum?: string;
    accessTierId?: number;
    dateUploadedUtc?: string;
    fileSizeInKb?: number;
    storageServiceResponseBody?: string;
    isActive: boolean;
    createdById?: number;
    createdAtUtc?: string;
    updatedById?: number;
    updatedAtUtc?: string;
}

export interface Tag {
    id: number;
    fileId: number;
    name?: string;
    description?: string;
    isActive: boolean;
    createdById?: number;
    createdAtUtc?: string;
    updatedById?: number;
    updatedAtUtc?: string;
}

const appUrlV2 = "/v2/files";

export const listFiles = async (pagedRequest: PageRequest) => {
  const response = await fileApi.post<PagedResponse<File>>(`${appUrlV2}/list`, pagedRequest);
  return response?.data;
};

export const getFileByInternalId = async (internalFileId: string) => {
  const response = await fileApi.get<File>(`${appUrlV2}/internal/${internalFileId}`);
  return response?.data;
};

export const getFileSecureLink = async (id: number) => {
  const response = await fileApi.get<string>(`${appUrlV2}/${id}/secureLink`);
  return response?.data;
};

export const downloadFile = async (id: number) => {
  const response = await fileApi.get(`${appUrlV2}/${id}/download`, {
    responseType: 'blob'
  });
  return response;
};

export const listFileTags = async (fileId: number, pagedRequest: PageRequest) => {
  const response = await fileApi.post<PagedResponse<Tag>>(`${appUrlV2}/${fileId}/tags/list`, pagedRequest);
  return response?.data;
};

export const addFileTag = async (fileId: number, name: string, description: string) => {
  const response = await fileApi.post<Tag>(`${appUrlV2}/${fileId}/tags`, { 
    Key: name,
    Value: description
  });
  return response?.data;
};

export const deleteFileTag = async (fileId: number, tagId: number) => {
  const response = await fileApi.delete<Tag>(`${appUrlV2}/${fileId}/tags/${tagId}`);
  return response?.data;
};

export interface UploadFileRequest {
  customerId: number;
  externalFileId?: string;
  file: File;
}

export const uploadFile = async (request: UploadFileRequest) => {
  const formData = new FormData();
  formData.append('files', request.file);
  formData.append('customerId', request.customerId.toString());
  if (request.externalFileId) {
    formData.append('externalFileId', request.externalFileId);
  }

  const response = await fileApi.post<File>(`${appUrlV2}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response?.data;
};

export const deleteFile = async (id: number): Promise<void> => {
  await fileApi.delete(`${appUrlV2}/${id}`);
};
